import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, InputError, Select } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { emptyError, resolveSubjectByTarget } from "../../../utils/commonUtils";
import { EMPTY, FEEDBACK_TARGETS, SUBJECT_KEY } from "../../../utils/enums";

const FeedbackTarget = observer(({ FeedbackStore }) => {
  const key = "target";
  const { feedback, updateError, updateValue, updateIncluded, updateTopic } =
    FeedbackStore;
  const target = feedback.target;
  const msgs = useMessageGetter("feedback.form.target");
  const subjectMsgs = useMessageGetter("feedback.form.subject");

  updateIncluded(key, true);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
    updateValue(SUBJECT_KEY, EMPTY);
    resolveTopic(value);
  };

  const resolveTopic = (value) => {
    updateTopic(resolveSubjectByTarget(value, EMPTY), subjectMsgs);
  };

  const handleOnBlur = () => {
    if (!target.value) updateError(key, emptyError(msgs));
  };

  return (
    <div className="cff-feedbackTarget">
      <FormRow
        label={msgs("label")}
        labelFor={`CFF-${key}`}
        labelId={`cff-feedbackTarget`}
      >
        <Select
          id={`CFF-${key}`}
          name={key}
          value={target.value}
          onChange={(e) => handleOnChange(e.target.value)}
          onBlur={handleOnBlur}
          invalid={!!target.error}
          aria-describedby={!!target.error ? `CFF-${key}-error` : null}
          aria-required={true}
        >
          <option value="">{msgs("option.default")}</option>
          {FEEDBACK_TARGETS.map((option) => (
            <option key={option} value={option}>
              {msgs(`option.${option}`)}
            </option>
          ))}
        </Select>
        <InputError
          error={target.error ? target.error : null}
          id={`CFF-${key}-error`}
        />
      </FormRow>
    </div>
  );
});

export default inject("FeedbackStore")(FeedbackTarget);
